import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { BackgroundColorContainer, MainDiv } from 'components/styles_components/container';
import { isAuthenticated } from 'utils/authentication';
import { useSpace } from 'contexts/space';
import { MenuProvider, useMenu } from 'contexts/menu';
import { ProfileLink, SpacesLink } from 'utils/link';
import SideMenu from 'components/layout/side_menu';
import MainContainer from 'components/layout/main_container';
import useMobile from 'hooks/use_mobile';
import theme from 'theme';

const PrivateLayout = () => {
  const isMobile = useMobile();
  const { sidebarVisible } = useMenu();
  const style = sidebarVisible && !isMobile ? { marginLeft: theme.width.sideMenu } : {};

  return (
    <BackgroundColorContainer>
      <MainDiv style={style}>
        <SideMenu />
        <MainContainer>
          <Outlet />
        </MainContainer>
      </MainDiv>
    </BackgroundColorContainer>
  );
};

const PrivateRoute = () => {
  const { currentSpaceId } = useSpace();
  const { pathname } = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/users/login" />;
  }

  const allowedWithoutSpace = [ProfileLink(), SpacesLink()];
  if (!currentSpaceId && !allowedWithoutSpace.includes(pathname)) {
    return <Navigate to={SpacesLink()} />;
  }

  return (
    <MenuProvider>
      <PrivateLayout />
    </MenuProvider>
  );
};

export default PrivateRoute;
